// Author - Abhinav Acharya Tirumala Vinjamuri
import ComingSoon from './ComingSoon';
export default ComingSoon;